/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
} from './EventName';

/**
 * 
 * @export
 * @interface SDKEventSlashIDSDKLoadedV1
 */
export interface SDKEventSlashIDSDKLoadedV1 {
    /**
     * 
     * @type {EventName}
     * @memberof SDKEventSlashIDSDKLoadedV1
     */
    event_name: EventName;
}

/**
 * Check if a given object implements the SDKEventSlashIDSDKLoadedV1 interface.
 */
export function instanceOfSDKEventSlashIDSDKLoadedV1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;

    return isInstance;
}

export function SDKEventSlashIDSDKLoadedV1FromJSON(json: any): SDKEventSlashIDSDKLoadedV1 {
    return SDKEventSlashIDSDKLoadedV1FromJSONTyped(json, false);
}

export function SDKEventSlashIDSDKLoadedV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventSlashIDSDKLoadedV1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
    };
}

export function SDKEventSlashIDSDKLoadedV1ToJSON(value?: SDKEventSlashIDSDKLoadedV1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_name': EventNameToJSON(value.event_name),
    };
}

